var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopularPlanMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 7.49999C15.8337 8.70832 15.4753 9.81667 14.8587 10.7417C13.9587 12.075 12.5337 13.0167 10.8753 13.2583C10.592 13.3083 10.3003 13.3333 10.0003 13.3333C9.70033 13.3333 9.40866 13.3083 9.12533 13.2583C7.46699 13.0167 6.04199 12.075 5.14199 10.7417C4.52533 9.81667 4.16699 8.70832 4.16699 7.49999C4.16699 4.27499 6.77533 1.66666 10.0003 1.66666C13.2253 1.66666 15.8337 4.27499 15.8337 7.49999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7082 15.3917L16.3332 15.7167C16.0249 15.7917 15.7832 16.025 15.7166 16.3333L15.4249 17.5583C15.2666 18.225 14.4166 18.425 13.9749 17.9L9.9999 13.3333L6.0249 17.9083C5.58324 18.4333 4.73324 18.2333 4.5749 17.5667L4.28324 16.3417C4.20824 16.0333 3.96657 15.7917 3.66657 15.725L2.29157 15.4C1.65824 15.25 1.43324 14.4583 1.89157 14L5.14157 10.75C6.04157 12.0833 7.46657 13.025 9.1249 13.2667C9.40824 13.3167 9.6999 13.3417 9.9999 13.3417C10.2999 13.3417 10.5916 13.3167 10.8749 13.2667C12.5332 13.025 13.9582 12.0833 14.8582 10.75L18.1082 14C18.5666 14.45 18.3416 15.2417 17.7082 15.3917Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4836 4.98334L10.9753 5.96667C11.042 6.1 11.217 6.23334 11.3753 6.25834L12.267 6.40834C12.8336 6.5 12.967 6.91667 12.5586 7.32501L11.867 8.01666C11.7503 8.13333 11.6836 8.35834 11.7253 8.52501L11.9253 9.38334C12.0836 10.0583 11.7253 10.325 11.1253 9.96666L10.292 9.475C10.142 9.38333 9.89197 9.38333 9.74197 9.475L8.90864 9.96666C8.30864 10.3167 7.9503 10.0583 8.10864 9.38334L8.30864 8.52501C8.34197 8.36668 8.28364 8.13333 8.16697 8.01666L7.4753 7.32501C7.06697 6.91667 7.2003 6.50834 7.76697 6.40834L8.65864 6.25834C8.80864 6.23334 8.98364 6.1 9.0503 5.96667L9.54197 4.98334C9.78364 4.45001 10.217 4.45001 10.4836 4.98334Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularPlanMedal);
export default __webpack_public_path__ + "static/media/popular-plan-medal.470041b48dca2256e35b39fbe2caa272.svg";
export { ForwardRef as ReactComponent };